import { RouteConfig } from 'vue-router';

import { PublicSettings } from '@/enums/publicSettings.enum';
import { TableName } from '@/enums/tableName';
import store from '@/store/store';
import { tryParseInt } from '@/utils/number';
import { getPaymentPack } from '@/utils/paymentList';
import Payments from '@/views/mainRoute/procedure/payments/Payments.vue';

export const procedurePaymentsRoute: RouteConfig = {
  path: ':packId',
  name: 'procedurePayments',
  component: Payments,
  meta: {
    breadcrumb: { title: 'Płatności' }
  },
  beforeEnter: (to, from, next) => {
    const entityType = TableName.procedure;
    const packId = tryParseInt(to.params.packId) as number;
    Promise.all([
      getPaymentPack(packId).then(pack => (procedurePaymentsRoute.meta.breadcrumb.title = pack.number)),
      store.dispatch('payment/list', {
        count: -1,
        start: 0,
        packId,
        structureIds: store.state.auth.nodes.map((node: any) => node.id) // permission related - school payment operator
      }),
      store
        .dispatch('setting/findPublic', {
          code: PublicSettings.CHILD_PROCEDURE_ID,
          entityType,
          entityId: to.params.procedureId.toString()
        })
        .then(setting => {
          const entityId = setting?.value || to.params.procedureId.toString();
          return Promise.all([
            store.dispatch('setting/findPublic', { code: PublicSettings.PAYMENT_NO_SPLIT, entityId, entityType }),
            store.dispatch('setting/findPublic', { code: PublicSettings.PAYMENT_COLUMNS, entityId, entityType })
          ]);
        })
    ]).then(() => next());
  }
};
